export enum InlineNotificationType {
  Error = 'Error',
  Warning = 'Warning',
  Success = 'Success',
  Info = 'Info',
}

export enum InlineNotificationKey {
  BgColor = 'BgColor',
  Border = 'Border',
  BorderLeftColor = 'BorderLeftColor',
  Svg = 'Svg',
}
